import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Paper } from "@material-ui/core";
import Container from "@material-ui/core/Container";

import rohan from "../assets/images/rohan.png";
import aldric from "../assets/images/aldric.png";
import brijesh from "../assets/images/brijesh.png";
import anthony from "../assets/images/anthony.png";
import william from "../assets/images/william.png";
import isaac from "../assets/images/isaac.jpeg";
import simarya from "../assets/images/simarya.jpeg";
import sai from "../assets/images/sai.jpg";
import sam from "../assets/images/sam.jpg";
import om from "../assets/images/om.jpg";
import zixuan from "../assets/images/zixuan.jpg";
import aaron from "../assets/images/aaron.jpeg";
import adam from "../assets/images/adam.png";
import emily from "../assets/images/emily.png";
import ethan from "../assets/images/ethan.jpeg";
import rajiv from "../assets/images/rajiv.png";
import charles from "../assets/images/charles.jpeg";
import pratyay from "../assets/images/pratyay.png";
import neel from "../assets/images/neel.png";
import josh from "../assets/images/josh.png";
import rohans from "../assets/images/rohans.png";
import ishaan from "../assets/images/ishaan.jpeg";
import arpit from "../assets/images/arpit.jpeg";
import Scroll from "../components/Scroll";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
  },
  element: {
    padding: theme.spacing(2),
    textAlign: "left",
    height: "100%",
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  flex: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  imageCropper: {
    position: "relative",
    width: "150px",
    height: "150px",
    overflow: "hidden",
    borderRadius: "50%",
    borderColor: "#FF5B4D",
    borderWidth: "5px",
    borderStyle: "solid",
    marginBottom: "10px",
  },
  profilePic: {
    objectFit: "contain",
    display: "inline",
    margin: "0 auto",
    width: "auto",
  },
}));

export default function Team() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Scroll showBelow={150} />
      <Grid container spacing={3} style={{ justifyContent: "center" }}>
        <Grid item xs={12}>
          <Typography variant="h3" component="h2">
            <b>Our Team</b>
          </Typography>
        </Grid>
        <Grid item md={6} xs={12}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                  alt=""
                  className={classes.profilePic}
                  src={rohan}
                  style={{
                    marginLeft: "-78%",
                    height: "150%",
                  }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Rohan Kumar</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Tournament Director
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Senior at Saratoga High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={6} xs={12}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                  alt=""
                  className={classes.profilePic}
                  src={anthony}
                  style={{
                    marginLeft: "0%",
                    height: "100%",
                  }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Anthony Wang</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Tournament Director
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Sophomore at Saratoga High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={william}
                style={{
                  marginTop: "-5%",
                  marginLeft: "-10%",
                  height: "150%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>William Y. Feng</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Freshman at Lakeside Upper School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={sai}
                style={{
                  marginTop: "-5%",
                  marginLeft: "-40%",
                  height: "140%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Sai Anoop Avunuri</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Senior at Walton High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={sam}
                style={{
                  marginTop: "0%",
                  marginLeft: "-25%",
                  height: "130%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Sam Lu</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Junior at Obra D. Tompkins High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={ethan}
                style={{
                  marginTop: "-30%",
                  marginLeft: "-10%",
                  height: "175%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Ethan Poladian</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Junior at Redondo Union High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={isaac}
                style={{
                  marginTop: "-80%",
                  marginLeft: "-15%",
                  height: "250%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Isaac Chang</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Senior at Saratoga High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={brijesh}
                style={{
                  marginTop: "-5%",
                  marginLeft: "-12%",
                  height: "105%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Brijesh Molala</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Senior at Van Nuys High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={simarya}
                style={{
                  marginTop: "-10%",
                  marginLeft: "-52%",
                  height: "200%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Simarya Ahuja</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Freshman at Saratoga High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={zixuan}
                style={{
                  marginTop: "-5%",
                  marginLeft: "-10%",
                  height: "125%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Zixuan (Andrea) Zhang</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Senior at Abraham Lincoln High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={adam}
                style={{
                  marginTop: "-0.5%",
                  marginLeft: "-3%",
                  height: "105%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b> Adam Xu</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Sophomore at Saratoga High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={aaron}
                style={{
                  marginTop: "-10%",
                  marginLeft: "-1.5%",
                  height: "150%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Aaron Babajanyan</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Sophomore at Amity Regional High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={rohans}
                style={{
                  marginTop: "-25%",
                  marginLeft: "%",
                  height: "160%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Rohan Shelke</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Senior at Mira Loma High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={neel}
                style={{
                  marginTop: "-15%",
                  marginLeft: "-27%",
                  height: "150%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Neel Gajare</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Sophomore at Archbishop Mitty High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={emily}
                style={{
                  marginTop: "-25%",
                  marginLeft: "-30%",
                  height: "200%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Emily Xing</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Sophomore at Centennial High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={om}
                style={{
                  marginTop: "-60%",
                  marginLeft: "-25%",
                  height: "200%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Om Awate</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Junior at American High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={pratyay}
                style={{
                  marginTop: "-23%",
                  marginLeft: "-23%",
                  height: "150%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Pratyay Pandey</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Freshman at Mission San Jose High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={josh}
                style={{
                  marginTop: "-45%",
                  marginLeft: "-8%",
                  height: "200%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Josh Ingleson</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Junior at Walton High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={rajiv}
                style={{
                  marginTop: "-5%",
                  marginLeft: "-58%",
                  height: "300%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Rajiv Mallisetty</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Freshman at Jasper High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={charles}
                style={{
                  marginTop: "-65%",
                  marginLeft: "-90%",
                  height: "300%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Charles Yu</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Junior at Livingston High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                alt=""
                className={classes.profilePic}
                src={aldric}
                style={{
                  marginTop: "-10%",
                  marginLeft: "-7%",
                  height: "140%",
                }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Aldric Benalan</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              7th grader at Community Middle School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                  alt=""
                  className={classes.profilePic}
                  src={ishaan}
                  style={{
                    marginTop: "-17%",
                    marginLeft: "-12%",
                    height: "140%",
                  }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Ishaan Panigrahi</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Freshman at Montgomery High School
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={3} xs={6}>
          <Paper className={classes.paper}>
            <div className={classes.imageCropper}>
              <img
                  alt=""
                  className={classes.profilePic}
                  src={arpit}
                  style={{
                    marginTop: "-27%",
                    marginLeft: "0%",
                    height: "140%",
                  }}
              />
            </div>
            <Typography variant="h4" component="h2" gutterBottom>
              <b>Arpit Mittal</b>
            </Typography>
            <Typography variant="h5" component="h2" gutterBottom>
              Writer
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Freshman at Forsyth Central High School
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
